// extracted by mini-css-extract-plugin
export var dropdown = "_rw-0";
export var imageWrapper = "_rw-3";
export var itemNameContainer = "_rw-1";
export var productImage = "_rw-2";
export var spinnerWrapper = "_rw-4";